export const MAX_LENGTH = {

  AUTH_ID: 26,

  FACILITY_ID: 20,
  FACILITY_NAME: 60,

  CAREGIVER_ID: 10,
  CAREGIVER_NAME: 20,
  CAREGIVER_PASSWORD: 32,

  BACKEND_URL: 100,

  DEVICE_ID: 30,
}
